/**
 * Script to generate 69 shop entries for Bandar Sri Indah
 */

// Shop name components for generating random names
const namePrefixes = [
  'Kedai', 'Toko', 'Dapur', 'Rumah', 'Warung', 'Restoran', 'Cafe', 'Kiosk', 'Outlet', 
  'Store', 'Shop', 'Mart', 'Market', 'Plaza', 'Point', 'Hub', 'Central', 'Corner', 'Spot'
];

const nameSuffixes = [
  'Sri Indah', 'Bandar', 'Taman', 'City', 'Town', 'Heights', 'Garden', 'Park', 
  'Square', 'Place', 'Zone', 'Area', 'Village', 'Complex', 'Center', 'Point'
];

const businessTypes = [
  'Makanan', 'Minuman', 'Elektronik', 'Pakaian', 'Kosmetik', 'Perabot', 'Alat Tulis', 
  'Sukan', 'Muzik', 'Buku', 'Hadiah', 'Bunga', 'Daging', 'Ikan', 'Sayur', 'Buah',
  'Roti', 'Kuih', 'Ais Krim', 'Kopi', 'Teh', 'Jam', 'Kaca Mata', 'Kasut', 'Beg',
  'Perhiasan', 'Mainan', 'Komputer', 'Telefon', 'Kamera', 'TV', 'Radio', 'Permainan',
  'Motosikal', 'Kereta', 'Basikal', 'Sukan Air', 'Kemah', 'Memancing', 'Golf'
];

// Categories
const categories = [
  'Food & Beverage', 'Grocery', 'Healthcare', 'Fashion', 'Electronics', 'Education',
  'Fitness', 'Beauty', 'Toys', 'Home', 'Automotive', 'Sports', 'Books', 'Jewelry',
  'Flowers', 'Gifts', 'Music', 'Photography', 'Stationery', 'Furniture', 'Appliances',
  'Bakery', 'Cafe', 'Restaurant', 'Fast Food', 'Convenience', 'Supermarket', 'Pharmacy',
  'Clinic', 'Dental', 'Optical', 'Gym', 'Spa', 'Salon', 'Barbershop', 'Pet Shop'
];

// Descriptions
const descriptions = [
  'Local favorite with authentic products',
  'Premium quality at affordable prices',
  'One-stop shop for all your needs',
  'Friendly service with a smile',
  'Wide selection of imported goods',
  'Traditional recipes with modern twist',
  'Expert staff ready to assist you',
  'Convenient location with ample parking',
  'Family-owned business since 2010',
  'Award-winning products and service',
  'Sustainable and eco-friendly options',
  'Latest trends and fashion items',
  'High-quality products guaranteed',
  'Specializing in custom orders',
  'Fast and efficient service',
  'Knowledgeable and helpful staff',
  'Comfortable and welcoming atmosphere',
  'Competitive prices and great deals',
  'Fresh products daily',
  'Popular among locals and tourists'
];

// Promotions
const promotions = [
  'Weekend special: 20% off all items',
  'Buy 1 Get 1 Free on selected items',
  'Happy Hour: 3PM-6PM daily',
  'Lunch special: 10% discount',
  'Member exclusive deals',
  'Seasonal sale: Up to 50% off',
  'Flash sale: Today only!',
  'Bundle deals available',
  'Free delivery for orders above RM50',
  'First-time customer discount',
  'Student discount with valid ID',
  'Senior citizen special: 15% off',
  'Early bird specials',
  'Loyalty program rewards',
  'Gift with purchase',
  'Clearance sale: While stocks last',
  'Festive promotions',
  'New product launch deals',
  'Anniversary celebration offers',
  'Limited time offers'
];

// Operating hours
const operatingHours = [
  '7:00 AM - 10:00 PM',
  '8:00 AM - 9:00 PM',
  '9:00 AM - 8:00 PM',
  '10:00 AM - 10:00 PM',
  '24 Hours',
  '6:00 AM - 12:00 AM',
  '8:00 AM - 11:00 PM',
  '9:00 AM - 6:00 PM',
  '11:00 AM - 9:00 PM',
  '7:30 AM - 9:30 PM'
];

// Price ranges
const priceRanges = ['$', '$$', '$$$'];

// Phone number patterns
const phonePatterns = [
  '+60 123-456',
  '+60 124-789',
  '+60 125-012',
  '+60 126-345',
  '+60 127-678',
  '+60 128-901',
  '+60 129-234',
  '+60 130-567',
  '+60 131-890',
  '+60 132-123'
];

// Website patterns
const websitePatterns = [
  'https://{name}.example.com',
  'https://www.{name}.com',
  'https://{name}-online.com',
  'https://{name}-store.com',
  'https://shop-{name}.com'
];

/**
 * Generate a random shop name
 */
function generateShopName() {
  const prefix = namePrefixes[Math.floor(Math.random() * namePrefixes.length)];
  const suffix = nameSuffixes[Math.floor(Math.random() * nameSuffixes.length)];
  const business = businessTypes[Math.floor(Math.random() * businessTypes.length)];
  
  // Randomly combine 2-3 components
  const components = [prefix, business];
  if (Math.random() > 0.5) {
    components.push(suffix);
  }
  
  return components.join(' ');
}

/**
 * Generate a random phone number
 */
function generatePhone() {
  const pattern = phonePatterns[Math.floor(Math.random() * phonePatterns.length)];
  const suffix = Math.floor(Math.random() * 9000) + 1000; // 4-digit number
  return `${pattern}${suffix}`;
}

/**
 * Generate a random website URL
 */
function generateWebsite(name) {
  const pattern = websitePatterns[Math.floor(Math.random() * websitePatterns.length)];
  const cleanName = name.toLowerCase().replace(/\s+/g, '-');
  return pattern.replace('{name}', cleanName);
}

/**
 * Generate random coordinates around the center point
 */
function generateCoordinates(centerLat, centerLng, radius = 0.01) {
  // Generate random angle and distance
  const angle = Math.random() * 2 * Math.PI;
  const distance = Math.random() * radius;
  
  // Convert to lat/lng
  const lat = centerLat + (distance * Math.cos(angle));
  const lng = centerLng + (distance * Math.sin(angle));
  
  return { lat, lng };
}

/**
 * Generate a single shop object
 */
function generateShop(id, centerLat, centerLng) {
  const name = generateShopName();
  const category = categories[Math.floor(Math.random() * categories.length)];
  const { lat, lng } = generateCoordinates(centerLat, centerLng);
  const description = descriptions[Math.floor(Math.random() * descriptions.length)];
  const phone = generatePhone();
  const website = generateWebsite(name);
  const hours = operatingHours[Math.floor(Math.random() * operatingHours.length)];
  const rating = (Math.random() * 2 + 3).toFixed(1); // Rating between 3.0 and 5.0
  const priceRange = priceRanges[Math.floor(Math.random() * priceRanges.length)];
  const promotion = Math.random() > 0.3 ? promotions[Math.floor(Math.random() * promotions.length)] : null;
  const image = `https://via.placeholder.com/300x200?text=${encodeURIComponent(name)}`;
  
  return {
    id,
    name,
    category,
    lat: parseFloat(lat.toFixed(6)),
    lng: parseFloat(lng.toFixed(6)),
    description,
    phone,
    website,
    hours,
    rating: parseFloat(rating),
    priceRange,
    promotion,
    image
  };
}

/**
 * Generate an array of shops
 */
export function generateShops(count = 69, centerLat = 4.266512, centerLng = 118.0015594) {
  const shops = [];
  
  // Generate all shops using the generator
  for (let i = 1; i <= count; i++) {
    shops.push(generateShop(i, centerLat, centerLng));
  }
  
  return shops;
}